import { useNavigate, useParams } from "react-router-dom"

import useStockAdjustmentDetailRepositories from "repositories/stock-adjustment-detail"
import { StockAdjustmentContent } from "pages/stock-transfer/list"

export default function Form() {
  const navigate = useNavigate()
  const { id } = useParams()
  const isEdit = Boolean(id)

  const { data, isLoading } = useStockAdjustmentDetailRepositories(id, isEdit)
  const canEdit = !isEdit || String(data?.adjustment?.status || "").toUpperCase() === "DRAFT"

  return (
    <div className="space-y-6">
      <div className="p-5 bg-white border rounded-2xl border-neutral-200">
        <h2 className="text-lg font-semibold text-neutral-900">
          {isEdit ? "Edit Koreksi Stok" : "Buat Koreksi Stok"}
        </h2>
        <p className="mt-1 text-sm text-neutral-500">
          {isEdit
            ? "Ubah draft stock adjustment atau posting draft yang sudah ada."
            : "Buat stock adjustment baru dan simpan sebagai draft atau langsung posting."}
        </p>
      </div>

      {/* <div className="bg-white border rounded-2xl border-neutral-200 p-1"> */}
        {isEdit && isLoading ? (
          <div className="p-10 text-sm text-center text-neutral-500">Memuat draft stock adjustment...</div>
        ) : (
          <StockAdjustmentContent
            adjustmentId={id || null}
            initialData={data || null}
            onClose={() => navigate("/stock-adjustment")}
            canSubmit={canEdit}
            onSuccess={(result) => {
              const nextId = result?.id || id
              navigate(nextId ? `/stock-adjustment/${nextId}/edit` : "/stock-adjustment")
            }}
          />
        )}
      </div>
    // </div>
  )
}
